import * as d3 from 'd3';
import drawCartography from './drawCartography';
import { updateBogota, filterLocations, drawLocationPoints, updateSubunits, updateCartography } from './drawBogota';

export const createMap = (props, d3Render) => {
  const { id } = props;
  const chart = d3Render({...props});
  d3.select(`#${ id }`)
    .call(chart);
};

export const addSubunits = props => {
  const { id } = props;
  const chart = updateSubunits({...props });
  d3.select(`#${ id }`)
      .call(chart);
}

export const updateMap = props => {
  const { id } = props;
  const chart = updateCartography({...props});
  d3.select(`#${ id }`)
    .call(chart);
};

export const changeSector = props => {
  const { id } = props;
  const chart = updateBogota({ ...props });
  d3.select(`#${ id }`)
      .call(chart);
};

export const drawLocations = props => {
  const { id } = props;
  const chart = drawLocationPoints({ ...props });
  d3.select(`#${ id }`)
      .call(chart);
};

export const removeLocations = props => {
  const { id } = props;
  const chart = filterLocations({ ...props, opacity: 0 });
  d3.select(`#${ id }`)
      .call(chart);
};

export const addLocations = props => {
  const { id } = props;
  const chart = filterLocations({ ...props, opacity: 1 });
  d3.select(`#${ id }`)
      .call(chart);
};


